/**
 * date 2022 04 01
 * 共用接口存放
 * 因后期拿到的接口  所以之前其他模块使用到的就不做更改了  以后从这个文件获取共用接口

 */
import httpRequest from '@/utils/request.js'

export const shareParam = (params = {}) =>
  httpRequest.httpGet({
    url: '/service/share/param',
    params: {
      ...params
    }
  })
export const shareRoleType = (params = {}) =>
  httpRequest.httpGet({
    url: '/service/share/roleType',
    params: {
      ...params
    }
  })
export const shareScope = (params = {}) =>
  httpRequest.httpGet({
    url: '/service/share/scope',
    params: {
      ...params
    }
  })
// 公共树
export const shareTree = (params = {}) =>
  httpRequest.httpGet({
    url: '/service/share/tree',
    params: {
      ...params
    }
  })

/** 获取电子签名数据 */
export const shareSignature = (params = {}) =>
  httpRequest.httpGet({
    url: '/service/share/signature/detail',
    params: {
      ...params
    }
  })
/** 保存电子签名数据 */
export const shareSignatureSave = data =>
  httpRequest.httpPost('/service/share/signature/save', data)

// 传感器 导出
export const shareExportHistory = (data = {}) =>
  httpRequest.httpPost('/service/share/exportHistory', data)
// 查询传感器历史正常、异常记录、折线图接口 -弃用
// export const getTempHistoryData = (params = {}) => httpRequest.httpGet({
//     url: '/service/share/getTempHistoryData', params: {
//         ...params
//     }
// })
// 传感器获取实时数据接口 - 弃用
// export const monitorRealtime = (params = {}) => httpRequest.httpGet({
//     url: '/service/share/monitor/realtime', params: {
//         ...params
//     }
// })

// 传感器 历史记录 查询详情
export const shareHistory = (params = {}) =>
  httpRequest.httpGet({
    url: '/service/share/history',
    params: {
      ...params
    }
  })
// 获取计量单位
export const shareUnit = (params = {}) =>
  httpRequest.httpGet({
    url: '/service/share/unit',
    params: {
      ...params
    }
  })
// 下载文件
export const sensorGenerate = data =>
  httpRequest.httpPost('/service/share/sensorgenerate', data)
// 导出
export const exportFile = (data = {}, isqs) =>
  httpRequest.exportPost('/service/share/sensorgenerate', data, isqs)

// 获取设备类型 date 2022 06 21 web:brian server:crane 	sensor-传感器，gateway-网关，display-显示屏，relay-中继
export const shareGetDeviceType = type =>
  httpRequest.httpGet({
    url: '/service/share/getDeviceType/' + type
  })

// 获取监测点类型
export const getCarrierType = () =>
  httpRequest.httpGet({
    url: '/service/share/getCarrierType'
  })

// 获取转发平台
export const getForward = () =>
  httpRequest.httpGet({
    url: '/service/share/forward'
  })

// 获取单位
export const getUnit = () =>
  httpRequest.httpGet({
    url: '/service/share/unit'
  })

// 获取所有的设备类型
export const getDeviceType = () =>
  httpRequest.httpGet({
    url: '/service/share/getDeviceType'
  })

// 获取全路径
export const getFullPath = (carrierId, sceneId) =>
  httpRequest.httpGet({
    url: '/service/share/getFullScene',
    params: {
      sceneId,
      carrierId
    }
  })
// 获取取样凭据
export const getSampleCredentials = (
  carrierId,
  time,
  probe = 'temp',
  min = '',
  max = ''
) =>
  httpRequest.httpGet({
    url: '/service/share/carrier/sample/history/detail',
    params: {
      carrierId,
      time,
      probe,
      min,
      max
    }
  })

/**
 *
 * @param tag 传感器Tag
 * @param key temp|hum
 * @returns {Promise<unknown>}
 */
export const getProbe = (tag, key) =>
  httpRequest.httpGet({
    url: '/service/share/probeRange',
    params: {
      tag,
      key
    }
  })

/**
 * 数据备份列表
 * @param params
 * @returns {Promise | Promise<unknown>}
 */
export const getBackupFileData = params =>
  httpRequest.httpGet({
    url: '/service/share/backup/file/list',
    params
  })

/**
 * 下载数据备份
 * @param path
 * @returns {Promise | Promise<unknown>}
 */
export const downloadBackupFile = path =>
  httpRequest.download('/service/share/download', { path })

/**
 * 根据条件获取备份文件
 */
export const getBackupScene = params =>
  httpRequest.httpGet({
    url: '/service/share/backup/scene',
    params
  })

/**
 * 获取详细数据(温湿度)
 * @param params
 * @returns {Promise | Promise<unknown>}
 */
export const getDetailTempHumData = params =>
  httpRequest.httpGet({
    url: '/service/share/carrier/device/history/block',
    params
  })
/**
 * 获取 位置列表
 */
export const getLocationList = params =>
  httpRequest.httpGet({
    url: '/service/share/location',
    params
  })
/**
 * 获取 群组列表
 */
export const getGroupList = params =>
  httpRequest.httpGet({
    url: '/service/share/group',
    params
  })

export const uploadFile = data =>
  httpRequest.httpPost('/service/share/upload', data)
